<template>
  <v-skeleton-loader
    :loading="loading"
    height="220px"
    transition="none"
    type="image"
  >
    <circle-statistic
      :color="color"
      :icon="icon"
      :sub-title="subTitle"
      :value="this.bestResult.toString()"
      caption="Baseado nos últimos"
      sub-text="Last 24 Hours"
      title="Melhor aproveitamento"
    />
  </v-skeleton-loader>
</template>

<script>
import MiniStatistic from "../statistic/MiniStatistic";
import DashboardService from "@/services/dashboard.service";
import CircleStatistic from "../statistic/CircleStatistic";

export default {
  components: { CircleStatistic, MiniStatistic },
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String,
    dateRange: {
      type: String,
      default: "currentDay",
    },
  },
  watch: {
    // whenever question changes, this function will run
    dateRange: function (newProp, oldProp) {
      this.dateRangeChanged();
    },
  },
  created() {
    this.dateRangeChanged();
  },
  data() {
    return {
      loading: true,
      bestResult: "-",
    };
  },
  methods: {
    dateRangeChanged() {
      this.loading = true;
      DashboardService.getBestScore(this.dateRange).then((r) => {
        this.bestResult =
          r.data.best_score == null ? "-" : parseInt(r.data.best_score);
        this.loading = false;
      });
    },
  },
};
</script>
